<template>
  <div class="scroll-list" ref='pullRefreshRef'>
    <PullToRefresh v-model:refreshing="refreshing" @refresh="onRefresh" :min-height="minHeight">
      <div class="tree-three" v-if="currentChildren.categoryLevel === 2 && currentChildren.hasChildren">
        <div
          class="tree-three-item"
          :style="{
            background: currentTreeThreeIndex === -1 ? getTreeThreeBackgroundColor() : '#F7F8F9',
            color: currentTreeThreeIndex === -1 ? themeColor : '#171921'
          }"
          @click="onSelectTreeThree(true, -1)"
        >
          全部
        </div>
        <div
          class="tree-three-item"
          :style="{
            background: currentTreeThreeIndex === index ? getTreeThreeBackgroundColor() : '#F7F8F9',
            color: currentTreeThreeIndex === index ? themeColor : '#171921'
          }"
          v-for="(item, index) in currentChildren.children"
          :key="item.id"
          @click="onSelectTreeThree(false, index)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="pay-course" v-if="goodsInfo.length" @click="showPay">
        <div class="pay-m">￥</div>
        <div class="pay-desc">
          <div>{{ $t('board_total_course_h5', { length: goodsInfo.length || 0 }) }}</div>
          <i class="iconfont icon-icon_tiaozhuan pay-jump"></i>
        </div>
      </div>
      <div class="list-title">{{ $t('app_total_course_h5', { length: total || 0 }) }}</div>
      <div v-if="data.length">
        <div @click="goDetail(item)" class="list-item" v-for="item in data" :key="item.id">
          <div class="video">
            <img class="video-cover" :src="item.coverImgUrl" alt=""/>
            <div class="video-desc" v-if="item.fileType + 1 > 0">
              <div class="video-desc-text">{{ getName(item.fileType + 1) }}</div>
            </div>
            <div class="video-tip" v-if="item.learnStatus === 1">
              <div class="video-tip-text">{{ $t('app_learned_short') }}</div>
            </div>
          </div>
          <div class="info">
            <div class="ct-box">
              <div class="pay-label" v-if="item.purchaseStatus === 1">
                <div class="pay-text">{{ $t('purchased') }}</div>
              </div>
              <div class="course-title">{{ item.fileName }}</div>
            </div>
            <div class="c-b">
              <div class="course-score">{{ item.score || 0 }}{{ $t('app_score') }}</div>
              <div class="course-line"></div>
              <div class="course-learn">{{ item.learnNum || 0 }}{{ $t('app_people_learning') }}</div>
            </div>
          </div>
        </div>
      </div>
      <Error
        v-else
        :status="{ info: $t('app_empty'), imgSrc: 'empty_cont.png' }"
        :self-style="{ width: '100%', height: 'calc(100vh - 150px)', background: 'none' }"
      />
    </PullToRefresh>
  </div>
</template>
<script setup lang="ts">
import { ref, computed, watch, onActivated } from 'vue'
import { useThemeColor, useThemeId, useThemeColorWithAlpha } from '@/utils/theme'
import { RecordHome, GoodsInfo } from '@/api/Models/CourseDetail'
import { useI18n } from 'vue-i18n'
import Error from '@/components/Error.vue'
import { TreeItem, ThildrenItem } from '../types'
import { onBeforeRouteLeave, useRouter } from 'vue-router'
import PullToRefresh from '@/components/PullToRefresh.vue'
const minHeight = 'calc(100vh - 100px)'

interface IProps {
  data: RecordHome[]
  total: number
  currentChildren: TreeItem | ThildrenItem
  goodsInfo: GoodsInfo[]
}
// eslint-disable-next-line
const props = withDefaults(defineProps<IProps>(), {
  data: () => [],
  goodsInfo: () => [],
  total: 0,
  currentChildren: () => ({
    id: '',
    name: '',
    parentId: '',
    categoryLevel: 0,
    courseNum: '',
    count: '',
    hasChildren: 0,
    children: []
  })
})
const themeColorWithAlpha = useThemeColorWithAlpha(0.2)
const themeLinearColorWithAlpha = useThemeColorWithAlpha(0.3)
const emits = defineEmits(['onSelectTreeThree', 'showPay', 'onRefresh'])
const refreshing = ref(false)
const { t } = useI18n()
const router = useRouter()
const themeColor = useThemeColor()
const themeType = useThemeId()
const currentTreeThreeIndex = ref(-1)
let scrollH = 0
const pullRefreshRef = ref()
onBeforeRouteLeave(() => {
  // 确保 pullRefreshRef 和其对应的 DOM 元素存在
  if (pullRefreshRef.value && pullRefreshRef.value.scrollTop) {
    // 获取滚动位置
    scrollH = pullRefreshRef.value.scrollTop
  }
})
// 在返回让页面滚动到之前的高度
onActivated(() => {
  try {
    pullRefreshRef.value.scroll(0, scrollH)
  } catch (e) {}
})
const onSelectTreeThree = (isAll: boolean, index: number) => {
  currentTreeThreeIndex.value = index
  const param = isAll ? props.currentChildren : props.currentChildren.children[currentTreeThreeIndex.value]
  emits('onSelectTreeThree', param)
}
const onRefresh = () => {
  if (refreshing.value) {
    refreshing.value = false
  }
  emits('onRefresh')
}
const getTreeThreeBackgroundColor = computed(() => () => {
  switch (themeType.value) {
    case 'red':
      return 'rgba(230, 0, 0, 0.25)'
    case 'blue':
      return 'rgba(0, 117, 255, 0.25)'
    case 'orange':
      return 'rgba(243, 155, 0, 0.25)'
  }
})

const payThemeTextColor = computed(() => {
  let color = ''
  switch (themeType.value) {
    case 'red':
      color = '#850000'
      break
    case 'blue':
      color = '#003685'
      break
    case 'orange':
      color = '#855500'
      break
  }
  return color
})
// 0 传不进来
const getName = computed(() => (type: number) => {
  // 类型 0:课程,1:文档,2:视频,3:图片
  switch (type) {
    case 1:
      return t('app_course')
    case 2:
      return t('tag_doc')
    case 3:
      return t('tag_video')
    case 4:
      return t('tag_pic')
    case 5:
      return t('audio')
  }
})
watch(
  [() => props.currentChildren],
  () => {
    currentTreeThreeIndex.value = -1
    pullRefreshRef.value.scroll(0, 0)
  },
  { deep: true }
)

const goDetail = (item: RecordHome) => {
  const paramsRouter = {
    id: item.fileId, // 课程包id
    courseId: '', // 课件id
    courseType: item.fileType >= 1 ? 'courseWare' : 'course',
    endingType: 0, // 结课方式
    channel: 0 // 渠道
  }
  router.push({ name: 'courseDetail', query: paramsRouter })
}

const showPay = () => {
  emits('showPay')
}
</script>
<style scoped lang="less">
.scroll-list {
  flex: 1;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  background: #fff;
  padding: 0 16px 0 10px;
  .tree-three {
    width: 100%;
    overflow-y: hidden;
    overflow-x: scroll;
    display: flex;
    align-items: center;
    height: 40px;
  }
  .tree-three::-webkit-scrollbar {
    display: none;
  }
  .tree-three-item {
    background: #f7f8f9;
    color: #171921;
    font-size: 12px;
    padding: 4px 12px;
    border-radius: 18px;
    margin-right: 12px;
    flex-shrink: 0;
  }
  .pay-course {
    width: 100%;
    height: 30px;
    border-radius: 6px;
    overflow: hidden;
    display: flex;
    align-items: center;
  }
  .pay-m {
    width: 30px;
    height: 100%;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    background: linear-gradient(to bottom right, v-bind(themeLinearColorWithAlpha), v-bind(themeColor));
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .pay-desc {
    flex: 1;
    height: 30px;
    background: v-bind(themeColorWithAlpha);
    color: v-bind(payThemeTextColor) !important;
    font-size: 13px;
    display: flex;
    align-items: center;
    text-indent: 8px;
  }
  .pay-jump {
    font-size: 13px;
    color: v-bind(payThemeTextColor) !important;
    margin-left: -4px;
  }
  .list-title {
    font-size: 14px;
    color: #b7b7b7;
    padding: 10px 0;
  }
  .list-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  .video {
    width: 90px;
    height: 51px;
    border-radius: 5px;
    overflow: hidden;
    position: relative;
  }
  .video-cover {
    width: 90px;
    height: 51px;
    border: none;
    border-radius: 5px;
  }
  .video-tip {
    height: 15px;
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 5px 0 5px 0;
    background: v-bind(themeColor);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 2px;
  }
  .video-tip-text {
    font-size: 12px;
    color: #fff;
    transform: scale(0.83);
    transform-origin: center;
  }
  .video-desc {
    padding: 0 2px;
    border-radius: 3px;
    background: rgba(0, 0, 0, 0.6);
    position: absolute;
    right: 4px;
    bottom: 4px;
  }
  .video-desc-text {
    font-size: 12px;
    color: #fff;
    transform: scale(0.83);
    transform-origin: center;
  }
  .info {
    margin-left: 8px;
    flex: 1;
  }
  .ct-box {
    display: flex;
    align-items: center;
  }
  .pay-label {
    height: 17px;
    background: #dbf6e0;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #0fc030;
    font-size: 12px;
    padding: 0 2px;
  }
  .pay-text {
    font-size: 12px;
    transform: scale(0.92);
    transform-origin: center;
    line-height: 17px;
  }
  .course-title {
    flex: 1;
    font-weight: 500;
    font-size: 14px;
    color: #171921;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }
  .c-b {
    margin-top: 10px;
    font-size: 12px;
    display: flex;
    align-items: center;
  }
  .course-score {
    transform: scale(0.85);
    transform-origin: center;
    color: v-bind(themeColor);
  }
  .course-line {
    width: 1px;
    height: 13px;
    background: #e1e1e1;
    margin: 0 4px;
  }
  .course-learn {
    transform: scale(0.85);
    transform-origin: center;
    color: #999999;
  }
}
</style>
